/* eslint guard-for-in: 0 */
// in custom-plotly.js

let Plotly;
if (process.browser) {
    Plotly = require('plotly.js/lib/core');

    // Load in the trace types for pie, and choropleth
    Plotly.register([require('plotly.js/lib/bar')]);
}

module.exports = Plotly;
